import React from 'react';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import BlogImage from 'components/blog/image';
import Subtitle from 'components/blog/subtitle';
import Title from 'components/blog/title';
import Link from 'components/common/link';
import FadeIn from 'components/common/transitions/FadeIn';
import { BlogPostContentType } from 'constants/blog';
import { makePostUrl } from 'constants/urls';
import { BlogPostFeedItem as BlogPostFeedItemType } from 'containers/blog/post/types';
import { mq } from 'utils/responsive';
import { theme } from 'utils/theme';
import TagRow from '../tagRow';

const BlogPostLi = styled.li`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;

  box-shadow: 0px 0px 14px -3px rgba(0, 0, 0, 0.26);
  &: hover {
    box-shadow: 0px 0px 20px -2px rgba(0, 0, 0, 0.32);
    background-color: ${theme.colors.gray100};
  }

  &: not(: last-child) {
    margin-bottom: 50px;
  }
`;

const InnerDiv = styled.div`
  padding-bottom: 10px;
  width: 100%;
`;

const PreviewImageDiv = styled.div`
  height: 300px;
  max-height: 300px;
  ${mq.ltsm`
    height: 200px;
    max-height: 200px;
  `}

  overflow: hidden;
  border-radius: 5px;
`;

// TODO: make the Subtitle/Title responsive instead, so we have the logic in one plance
// This logic also exists on the metadata of a post.
const ResponsiveDetailsBox = styled.div`
  padding: 0 40px;
  width: 100%;
  max-width: 100%;

  ${mq.ltsm`
    padding: 0 10px;
  `}
`;

type BlogPostFeedItemWithUrl = BlogPostFeedItemType & {
  path?: string;
};

const BlogPostFeedItem = ({
  id,
  title,
  subtitle,
  previewImage,
  path,
  tags,
}: BlogPostFeedItemWithUrl) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <FadeIn inView={inView}>
      <BlogPostLi ref={ref}>
        <Link href={makePostUrl(id, path)} key={id} stretchParent>
          <InnerDiv>
            <PreviewImageDiv>
              <BlogImage alt={title} type={BlogPostContentType.NORMAL_IMAGE} src={previewImage} />
            </PreviewImageDiv>
            <ResponsiveDetailsBox>
              <Title margin="15px 0">{title}</Title>
              <Subtitle margin="15px 0">{subtitle}</Subtitle>
              <TagRow tags={tags} />
            </ResponsiveDetailsBox>
          </InnerDiv>
        </Link>
      </BlogPostLi>
    </FadeIn>
  );
};

export default BlogPostFeedItem;
